import React from 'react';
import { AccountDetailsStep } from 'components/EmployeeDetails/BankAccountDetails/AddEditBankAccount/AccountDetailsStep';
import { FormProvider } from 'forms';
import { FormHeading } from 'components/EmployeeOnboarding/components/styles';
import { BankAccountCard } from './components/BankAccountCard';
import { useGetBankAccountDetails } from 'components/EmployeeDetails/BankAccountDetails/hooks/useGetBankAccountDetails';
import {
  bankAccountApprovalStatus,
  bankAccountVerificationStatus,
} from 'components/EmployeeDetails/BankAccountDetails/data';
import { Box, Spinner } from '@razorpay/blade/components';
import { ErrorView } from 'components/ui/ErrorView/ErrorView';
import { routePaths } from 'components/Routes/data';
import { useHistory } from 'react-router-dom';
import { useSavedEmployeeData } from './hooks/useSavedEmployeeData';

export const BankAccountDetails: React.FC = () => {
  const { shouldShowStatutoryDetailsStep } = useSavedEmployeeData();
  const history = useHistory();

  const handleContinue = () => {
    const pathname = shouldShowStatutoryDetailsStep
      ? routePaths.employeeOnboarding.employeeSelfOnboarding.statutoryDetails
      : routePaths.employeeOnboarding.employeeSelfOnboarding.personalDetails;
    history.push(pathname);
  };

  const handleBack = () => {
    history.push(routePaths.employeeOnboarding.employeeSelfOnboarding.kycDetails);
  };

  const {
    latestBankAccount,
    queryResponse: { isLoading, isFetching, isError, refetch, data },
  } = useGetBankAccountDetails();

  if (isLoading || isFetching) {
    return (
      <Box height="80vh" display="flex" alignItems="center" justifyContent="center">
        <Spinner accessibilityLabel="Loading" />
      </Box>
    );
  }

  if (isError) {
    <Box height="80vh" display="flex" alignItems="center" justifyContent="center">
      <ErrorView onRefetch={refetch} />
    </Box>;
  }

  return (
    <>
      <FormHeading
        width="584px"
        marginX="auto"
        marginTop="spacing.11"
        title="Bank Account Details"
        description="Your salary and payments will be sent to your account"
      />
      <FormProvider initialState={{}}>
        {latestBankAccount ? (
          <BankAccountCard
            accountNumber={latestBankAccount.account_number}
            ifsc={latestBankAccount.ifsc}
            isVerified={
              latestBankAccount.verification_status === bankAccountVerificationStatus.verified
            }
            isPendingOnApproval={
              latestBankAccount.approval_status === bankAccountApprovalStatus.pending
            }
            handleContinue={handleContinue}
            handleBack={handleBack}
          />
        ) : (
          <AccountDetailsStep
            showLabel={false}
            onSuccess={handleContinue}
            onBackClick={handleBack}
            StepContentWrapperProps={{
              height: 'fit-content',
              maxWidth: '584px',
              paddingX: 'spacing.7',
              borderColor: 'surface.border.gray.muted',
              borderWidth: 'thinner',
              borderRadius: 'large',
              overflowY: 'auto',
            }}
            StepActionsWrapperProps={{ maxWidth: '584px', padding: 'spacing.0' }}
            employeeName={data?.data?.meta?.employee_name ?? ''}
          />
        )}
      </FormProvider>
    </>
  );
};
